import { useAuth0 } from '@auth0/auth0-react'
import { useFlag } from '@unleash/proxy-client-react'
import { FF_ENABLE_FORETHOUGHT_CONTEXT_VARIABLES } from 'src/constants/feature-flags'
import { getForethoughtToken } from '../sduiService'
import { useQuery } from '@tanstack/react-query'

export const useGetForethoughtToken = () => {
  const { isAuthenticated } = useAuth0()
  const isForethoughtContextVariablesEnabled = useFlag(
    FF_ENABLE_FORETHOUGHT_CONTEXT_VARIABLES
  )
  const { data, ...rest } = useQuery({
    queryKey: ['forethought-token'],
    queryFn: getForethoughtToken,
    enabled: isAuthenticated && isForethoughtContextVariablesEnabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error) => failureCount < 2
  })

  return {
    ...rest,
    token: data
  }
}
